import { IJokerWinBanner } from "./src/interfaces/JokerWinBanner.interface";
import { defineJokerWinBanner } from "./src/constants/constants";

export { IJokerWinBanner, defineJokerWinBanner };
